import React, { useState } from "react";
import Header from "../components/Header";
import Header2 from "../components/Header2";
import Footer from "../components/Footer";

import "../assets/css/bootstrap.min.css";
import "../assets/css/style.css";
import "../assets/css/menu.css";
import "../assets/css/vendors.css";
import "../assets/css/icon_fonts/css/all_icons_min.css";
import "../assets/css/custom.css";

const doctorsData = [
  {
    name: "Dr. Priya Sharma",
    qualification: "MBBS, MS - Plastic Surgery",
    fee: " FREE Consultation",
    rating: "4.8/5",
    experience: "15 Years Experience",
    location: "2nd Floor, MS Tower, Banjara Hills, Hyderabad",
    phone: "080-6541-7705",
    online: true,
    image: "/assets/img/doctors/doctor1.jpg",
    specialization: "Breast Lift Specialist"
  },
  {
    name: "Dr. Anjali Mehta",
    qualification: "MBBS, MCh - Cosmetic Surgery",
    fee: " FREE Consultation",
    rating: "4.9/5",
    experience: "12 Years Experience",
    location: "Apurupa Urban, No 201, 2nd Floor, Image Gardens Rd, near Chirec School, Hyderabad",
    phone: "080-6541-7705",
    online: true,
    image: "/assets/img/doctors/doctor2.jpg",
    specialization: "Breast Rejuvenation Expert"
  },
  {
    name: "Dr. Rohan Verma",
    qualification: "MBBS, MS - Plastic Surgery",
    fee: " FREE Consultation",
    rating: "4.7/5",
    experience: "14 Years Experience",
    location: "Annapurna Kalyana Mandapam Srinagar Nagar, Dilsukhnagar, Hyderabad",
    phone: "080-6541-7705",
    online: true,
    image: "/assets/img/doctors/doctor1.jpg",
    specialization: "Mastopexy Surgery Expert"
  },
  {
    name: "Dr. Sneha Reddy",
    qualification: "MBBS, MCh - Plastic Surgery",
    fee: " FREE Consultation",
    rating: "4.6/5",
    experience: "11 Years Experience",
    location: "123 Green Avenue, Banjara Hills, Hyderabad",
    phone: "080-6541-7710",
    online: false,
    image: "/assets/img/doctors/doctor2.jpg",
    specialization: "Breast Contouring Specialist"
  },
  {
    name: "Dr. Kavita Patel",
    qualification: "MBBS, MS - Plastic Surgery",
    fee: " FREE Consultation",
    rating: "4.8/5",
    experience: "16 Years Experience",
    location: "45 Tower Road, Jubilee Hills, Hyderabad",
    phone: "080-6541-7720",
    online: true,
    image: "/assets/img/doctors/doctor1.jpg",
    specialization: "Advanced Breast Lift"
  },
  {
    name: "Dr. Arjun Kumar",
    qualification: "MBBS, MCh - Plastic Surgery",
    fee: "FREE Consultation",
    rating: "4.7/5",
    experience: "13 Years Experience",
    location: "21 MG Road, Hyderabad",
    phone: "080-6541-7730",
    online: false,
    image: "/assets/img/doctors/doctor2.jpg",
    specialization: "Combined Breast Procedures"
  },
];

const DoctorsSection = () => {
  const [showAll, setShowAll] = useState(false);
  const displayedDoctors = showAll ? doctorsData : doctorsData.slice(0, 6);

  return (
    <div style={{ padding: "80px 20px", backgroundColor: "#f8f9fa" }}>
      <div style={{ maxWidth: "1200px", margin: "0 auto", fontFamily: "'Poppins', sans-serif" }}>
        <div style={{ textAlign: "center", marginBottom: "50px" }}>
          <h2 style={{ fontSize: "42px", fontWeight: "800", color: "#0b1c39", marginBottom: "15px" }}>
            Our <span style={{ color: "#ffcb24" }}>Breast Lift Surgery Specialists</span>
          </h2>
          <p style={{ fontSize: "18px", color: "#555", maxWidth: "600px", margin: "0 auto", lineHeight: "1.8" }}>
            Expert surgical care for breast rejuvenation and lifting with natural-looking, long-lasting results.
          </p>
        </div>

        <div style={{ display: "flex", flexWrap: "wrap", gap: "25px", justifyContent: "space-between" }}>
          {displayedDoctors.map((doc, index) => (
            <div
              key={index}
              style={{
                flex: "0 0 calc(33.33% - 17px)",
                backgroundColor: "#fff",
                borderRadius: "16px",
                padding: "25px",
                boxShadow: "0 8px 30px rgba(0,0,0,0.08)",
                display: "flex",
                alignItems: "center",
                gap: "20px",
                border: "1px solid rgba(9,187,175,0.1)",
                transition: "transform 0.3s ease, box-shadow 0.3s ease",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "translateY(-5px)";
                e.currentTarget.style.boxShadow = "0 12px 35px rgba(0,0,0,0.12)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow = "0 8px 30px rgba(0,0,0,0.08)";
              }}
            >
              <div style={{ position: "relative", flexShrink: 0 }}>
                <img
                  src={doc.image}
                  alt={doc.name}
                  style={{
                    width: "95px",
                    height: "95px",
                    borderRadius: "50%",
                    objectFit: "cover",
                    border: "3px solid #09bbaf",
                    backgroundColor: "#f8f8f8",
                  }}
                />
                {doc.online && (
                  <span
                    style={{
                      position: "absolute",
                      bottom: "8px",
                      right: "8px",
                      width: "14px",
                      height: "14px",
                      backgroundColor: "#09bbaf",
                      borderRadius: "50%",
                      border: "2px solid #fff",
                    }}
                    title="Online"
                  ></span>
                )}
              </div>

              <div style={{ flex: 1 }}>
                <h3 style={{ fontSize: "18px", fontWeight: "700", color: "#0b1c39", marginBottom: "6px" }}>
                  {doc.name}
                </h3>
                <p style={{ color: "#09bbaf", fontSize: "14px", marginBottom: "6px", fontWeight: "600" }}>
                  {doc.specialization}
                </p>
                <p style={{ color: "#555", fontSize: "14px", marginBottom: "6px" }}>
                  {doc.qualification}
                </p>
                <p style={{ fontWeight: "600", color: "#09bbaf", marginBottom: "6px", fontSize: "15px" }}>
                  {doc.fee}
                </p>
                <div style={{ display: "flex", alignItems: "center", gap: "12px", marginBottom: "6px" }}>
                  <span style={{ fontSize: "14px", color: "#555" }}>⭐ {doc.rating}</span>
                  <span style={{ fontSize: "14px", color: "#555" }}>{doc.experience}</span>
                </div>
                <p style={{ fontSize: "13px", color: "#555", display: "flex", alignItems: "flex-start", gap: "6px", marginBottom: "6px", lineHeight: "1.4" }}>
                  📍 {doc.location}
                </p>
                <p style={{ fontSize: "13px", color: "#555", marginBottom: "15px" }}>
                  📞 {doc.phone}
                </p>

                <button
                  style={{
                    padding: "12px 20px",
                    border: "none",
                    borderRadius: "30px",
                    backgroundColor: "#ffcb24",
                    color: "#0b1c39",
                    cursor: "pointer",
                    width: "100%",
                    fontWeight: "600",
                    fontSize: "14px",
                    transition: "background-color 0.3s ease",
                  }}
                  onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#ffd84f")}
                  onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "#ffcb24")}
                >
                  Book Free Consultation
                </button>
              </div>
            </div>
          ))}
        </div>

        {!showAll && doctorsData.length > 6 && (
          <div style={{ textAlign: "center", marginTop: "40px" }}>
            <button
              onClick={() => setShowAll(true)}
              style={{
                padding: "14px 40px",
                fontSize: "16px",
                borderRadius: "12px",
                border: "none",
                backgroundColor: "#09bbaf",
                color: "#fff",
                cursor: "pointer",
                fontWeight: "700",
                boxShadow: "0 8px 25px rgba(9,187,175,0.3)",
                transition: "background-color 0.3s ease",
              }}
              onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#0dcfc2")}
              onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "#09bbaf")}
            >
              View More Doctors ▼
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

const BreastLiftSurgery = () => {
  const [activeTab, setActiveTab] = useState("overview");

  return (
    <>
      <Header />
      <Header2 />

      {/* Hero Section */}
      <section style={{
        background: "linear-gradient(135deg, #0b1c39 0%, #09bbaf 100%)",
        padding: "160px 0 100px",
        marginTop: "56px",
        color: "white",
        textAlign: "center",
        position: "relative",
        overflow: "hidden"
      }}>
        <div className="container" style={{ position: "relative", zIndex: 2 }}>
          <h1 style={{
            fontSize: "3.5rem",
            fontWeight: "800",
            marginBottom: "20px",
            color: "white"
          }}>
            Advanced Breast Lift Surgery
          </h1>
          <p style={{
            fontSize: "1.3rem",
            marginBottom: "30px",
            opacity: "0.9",
            maxWidth: "700px",
            margin: "0 auto 30px",
            lineHeight: "1.6"
          }}>
            Natural Breast Rejuvenation with 95% Success Rate. Restore Youthful Contour and Confidence.
          </p>
          <div style={{ display: "flex", justifyContent: "center", gap: "20px", flexWrap: "wrap" }}>
            <button style={{
              padding: "15px 35px",
              borderRadius: "30px",
              border: "none",
              backgroundColor: "#ffcb24",
              color: "#0b1c39",
              fontWeight: "700",
              fontSize: "1.1rem",
              cursor: "pointer",
              transition: "all 0.3s ease"
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = "#ffd84f";
              e.currentTarget.style.transform = "translateY(-2px)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = "#ffcb24";
              e.currentTarget.style.transform = "translateY(0)";
            }}>
              Book Free Consultation
            </button>
            <button style={{
              padding: "15px 35px",
              borderRadius: "30px",
              border: "2px solid #ffcb24",
              backgroundColor: "transparent",
              color: "#ffcb24",
              fontWeight: "700",
              fontSize: "1.1rem",
              cursor: "pointer",
              transition: "all 0.3s ease"
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = "#ffcb24";
              e.currentTarget.style.color = "#0b1c39";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = "transparent";
              e.currentTarget.style.color = "#ffcb24";
            }}>
              View Before & After Gallery
            </button>
          </div>
        </div>
      </section>

      {/* Stats Section */}
      <section style={{ backgroundColor: "#fff", padding: "60px 0", borderBottom: "1px solid #eee" }}>
        <div className="container">
          <div className="row">
            <div className="col-md-3 col-6 text-center">
              <div>
                <h2 style={{ color: "#09bbaf", fontWeight: "800", fontSize: "2.5rem", marginBottom: "10px" }}>95%</h2>
                <p style={{ color: "#0b1c39", fontWeight: "600" }}>Patient Satisfaction Rate</p>
              </div>
            </div>
            <div className="col-md-3 col-6 text-center">
              <div>
                <h2 style={{ color: "#09bbaf", fontWeight: "800", fontSize: "2.5rem", marginBottom: "10px" }}>2-4</h2>
                <p style={{ color: "#0b1c39", fontWeight: "600" }}>Hours Procedure Time</p>
              </div>
            </div>
            <div className="col-md-3 col-6 text-center">
              <div>
                <h2 style={{ color: "#09bbaf", fontWeight: "800", fontSize: "2.5rem", marginBottom: "10px" }}>4-6</h2>
                <p style={{ color: "#0b1c39", fontWeight: "600" }}>Weeks Recovery Time</p>
              </div>
            </div>
            <div className="col-md-3 col-6 text-center">
              <div>
                <h2 style={{ color: "#09bbaf", fontWeight: "800", fontSize: "2.5rem", marginBottom: "10px" }}>10+</h2>
                <p style={{ color: "#0b1c39", fontWeight: "600" }}>Years Lasting Results</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Doctors Section */}
      <DoctorsSection />

      {/* Navigation Tabs */}
      <section style={{ backgroundColor: "#fff", padding: "40px 0", borderBottom: "1px solid #eee" }}>
        <div className="container">
          <div style={{ display: "flex", justifyContent: "center", gap: "10px", flexWrap: "wrap" }}>
            {[
              { id: "overview", label: "Overview", icon: "📋" },
              { id: "candidates", label: "Candidates", icon: "🔍" },
              { id: "techniques", label: "Techniques", icon: "🎯" },
              { id: "procedure", label: "Procedure", icon: "🔬" },
              { id: "recovery", label: "Recovery", icon: "⚕️" },
              { id: "results", label: "Results", icon: "🔄" },
              { id: "faq", label: "FAQ", icon: "🛡️" }
            ].map(tab => (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                style={{
                  padding: "12px 24px",
                  borderRadius: "25px",
                  border: "none",
                  backgroundColor: activeTab === tab.id ? "#09bbaf" : "#f8f9fa",
                  color: activeTab === tab.id ? "white" : "#555",
                  fontWeight: "600",
                  cursor: "pointer",
                  transition: "all 0.3s ease"
                }}
              >
                {tab.label}
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* Main Content */}
      <div className="container" style={{ padding: "80px 15px" }}>

        {/* Comprehensive Overview */}
        <section style={{ marginBottom: "80px" }}>
          <div style={{ textAlign: "center", marginBottom: "60px" }}>
            <h2 style={{ fontSize: "36px", fontWeight: "800", color: "#0b1c39", marginBottom: "20px" }}>
              Complete Guide to <span style={{ color: "#09bbaf" }}>Breast Lift Surgery</span>
            </h2>
          </div>

          {/* What is Breast Lift Surgery */}
          <div style={{ marginBottom: "60px" }}>
            <div style={{
              backgroundColor: "#fff",
              borderRadius: "20px",
              padding: "50px",
              boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
              border: "1px solid rgba(9,187,175,0.1)"
            }}>
              <h3 style={{ color: "#0b1c39", fontSize: "28px", fontWeight: "800", marginBottom: "30px" }}>
                Understanding Breast Lift Surgery (Mastopexy)
              </h3>
              
              <p style={{ color: "#555", lineHeight: "1.8", fontSize: "1.1rem", marginBottom: "25px" }}>
                Breast lift surgery, medically known as mastopexy, is a cosmetic procedure designed to raise and 
                reshape sagging breasts by removing excess skin and tightening surrounding tissue. This surgical 
                intervention restores a more youthful breast contour while repositioning the nipple and areola 
                to a more natural, elevated position.
              </p>

              <div className="row">
                <div className="col-md-6">
                  <div style={{
                    backgroundColor: "#f8f9fa",
                    borderRadius: "15px",
                    padding: "25px",
                    borderLeft: "4px solid #09bbaf",
                    marginBottom: "25px"
                  }}>
                    <h5 style={{ color: "#0b1c39", fontWeight: "700", marginBottom: "15px" }}>Natural Rejuvenation</h5>
                    <p style={{ color: "#555", margin: 0 }}>
                      Unlike breast augmentation that increases size, a breast lift focuses on restoring 
                      shape and position while maintaining natural breast tissue. The procedure creates 
                      a more youthful silhouette without artificial implants.
                    </p>
                  </div>
                </div>
                <div className="col-md-6">
                  <div style={{
                    backgroundColor: "#f8f9fa",
                    borderRadius: "15px",
                    padding: "25px",
                    borderLeft: "4px solid #ffcb24",
                    marginBottom: "25px"
                  }}>
                    <h5 style={{ color: "#0b1c39", fontWeight: "700", marginBottom: "15px" }}>Customized Approach</h5>
                    <p style={{ color: "#555", margin: 0 }}>
                      Each breast lift is tailored to individual anatomy and aesthetic goals. Surgeons 
                      consider breast size, degree of sagging, skin quality, and patient preferences 
                      to create personalized surgical plans.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Ideal Candidates */}
          <div style={{ marginBottom: "60px" }}>
            <h3 style={{ color: "#0b1c39", fontSize: "28px", fontWeight: "800", marginBottom: "40px", textAlign: "center" }}>
              Ideal Candidates & Common Concerns
            </h3>

            <div className="row">
              {[
                {
                  title: "Post-Pregnancy Changes", 
                  description: "Breast sagging and volume loss after childbirth and breastfeeding",
                  details: "Most common reason for seeking breast lift"
                },
                {
                  title: "Weight Fluctuations", 
                  description: "Significant weight loss causing skin stretching and breast ptosis",
                  details: "Often combined with breast augmentation"
                },
                {
                  title: "Aging Effects", 
                  description: "Natural aging process leading to decreased skin elasticity and sagging",
                  details: "Gradual descent over time"
                },
                {
                  title: "Genetic Predisposition", 
                  description: "Naturally heavy breasts or poor skin elasticity causing early sagging",
                  details: "Can affect younger women too"
                },
                {
                  title: "Asymmetry Correction", 
                  description: "Uneven breast position or significant size difference between breasts",
                  details: "Creates balanced appearance"
                },
                {
                  title: "Nipple Position", 
                  description: "Nipples pointing downward or falling below breast crease",
                  details: "Key indicator for breast lift need"
                }
              ].map((candidate, index) => (
                <div key={index} className="col-lg-4 col-md-6 mb-4">
                  <div style={{
                    backgroundColor: "#fff",
                    borderRadius: "15px",
                    padding: "25px",
                    boxShadow: "0 8px 25px rgba(0,0,0,0.08)",
                    border: "1px solid rgba(9,187,175,0.1)",
                    height: "100%",
                    transition: "transform 0.3s ease"
                  }}
                  onMouseEnter={(e) => e.currentTarget.style.transform = "translateY(-5px)"}
                  onMouseLeave={(e) => e.currentTarget.style.transform = "translateY(0)"}>
                    <h5 style={{ color: "#0b1c39", fontWeight: "700", marginBottom: "15px", fontSize: "1.2rem" }}>
                      {candidate.title}
                    </h5>
                    <p style={{ color: "#555", fontSize: "1rem", lineHeight: "1.6", marginBottom: "15px" }}>
                      {candidate.description}
                    </p>
                    <div style={{
                      backgroundColor: "#f8f9fa",
                      borderRadius: "8px",
                      padding: "12px",
                      borderLeft: "3px solid #09bbaf"
                    }}>
                      <p style={{ color: "#666", fontSize: "0.9rem", lineHeight: "1.5", margin: 0 }}>
                        {candidate.details}
                      </p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Surgical Techniques */}
          <div style={{ marginBottom: "60px" }}>
            <h3 style={{ color: "#0b1c39", fontSize: "28px", fontWeight: "800", marginBottom: "40px", textAlign: "center" }}>
              Breast Lift Techniques & Approaches
            </h3>

            <div style={{
              backgroundColor: "#fff",
              borderRadius: "20px",
              padding: "40px",
              boxShadow: "0 10px 30px rgba(0,0,0,0.08)"
            }}>
              <div className="row">
                {[
                  {
                    type: "Crescent Lift",
                    description: "Minimal incision around top half of areola for very mild sagging",
                    treatment: "Minimal scarring, quick recovery, subtle lift"
                  },
                  {
                    type: "Peri-Areolar (Donut)",
                    description: "Circular incision around areola for moderate sagging and areola reduction",
                    treatment: "Minimal visible scarring, good for small lifts"
                  },
                  {
                    type: "Vertical (Lollipop)",
                    description: "Incisions around areola and vertically down to breast crease",
                    treatment: "Moderate sagging correction, better shaping"
                  },
                  {
                    type: "Anchor (Inverted-T)",
                    description: "Most comprehensive technique with three incisions for significant sagging",
                    treatment: "Maximum lifting and reshaping, more scarring"
                  },
                  {
                    type: "No Vertical Scar",
                    description: "Advanced technique avoiding vertical scar while providing significant lift",
                    treatment: "Excellent results with hidden scars"
                  },
                  {
                    type: "Combined with Augmentation",
                    description: "Breast lift with implants for both lifting and volume enhancement",
                    treatment: "Comprehensive breast rejuvenation"
                  }
                ].map((technique, index) => (
                  <div key={index} className="col-lg-6 mb-4">
                    <div style={{
                      backgroundColor: "#f8f9fa",
                      borderRadius: "15px",
                      padding: "25px",
                      border: "2px solid #09bbaf",
                      height: "100%"
                    }}>
                      <h5 style={{ color: "#0b1c39", fontWeight: "700", marginBottom: "15px", fontSize: "1.2rem" }}>
                        {technique.type}
                      </h5>
                      <p style={{ color: "#555", fontSize: "1rem", lineHeight: "1.6", marginBottom: "15px" }}>
                        {technique.description}
                      </p>
                      <div style={{
                        backgroundColor: "#09bbaf",
                        color: "white",
                        padding: "8px 15px",
                        borderRadius: "20px",
                        display: "inline-block",
                        fontSize: "0.9rem",
                        fontWeight: "600"
                      }}>
                        {technique.treatment}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Pre-operative Preparation */}
          <div style={{ marginBottom: "60px" }}>
            <div style={{
              backgroundColor: "#0b1c39",
              borderRadius: "20px",
              padding: "50px",
              color: "white"
            }}>
              <h3 style={{ fontSize: "28px", fontWeight: "800", marginBottom: "30px", color: "#ffcb24" }}>
                Pre-operative Preparation & Requirements
              </h3>
              
              <div className="row">
                <div className="col-md-6">
                  <div style={{ marginBottom: "25px" }}>
                    <h5 style={{ color: "#ffcb24", fontWeight: "700", marginBottom: "15px" }}>Medical Evaluation</h5>
                    <ul style={{ color: "rgba(255,255,255,0.9)", paddingLeft: "20px" }}>
                      <li style={{ marginBottom: "10px" }}>Comprehensive health assessment</li>
                      <li style={{ marginBottom: "10px" }}>Mammogram within past year</li>
                      <li style={{ marginBottom: "10px" }}>Blood tests and medical clearance</li>
                      <li style={{ marginBottom: "10px" }}>Medication review and adjustments</li>
                      <li>Smoking cessation 4-6 weeks prior</li>
                    </ul>
                  </div>
                </div>
                <div className="col-md-6">
                  <div style={{ marginBottom: "25px" }}>
                    <h5 style={{ color: "#ffcb24", fontWeight: "700", marginBottom: "15px" }}>Lifestyle Preparation</h5>
                    <ul style={{ color: "rgba(255,255,255,0.9)", paddingLeft: "20px" }}>
                      <li style={{ marginBottom: "10px" }}>Stable weight for 3-6 months</li>
                      <li style={{ marginBottom: "10px" }}>Arrange for help during recovery</li>
                      <li style={{ marginBottom: "10px" }}>Purchase surgical bras and supplies</li>
                      <li style={{ marginBottom: "10px" }}>Plan for 2 weeks off work</li>
                      <li>Complete family planning</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Treatment Options */}
          <div style={{ marginBottom: "60px" }}>
            <h3 style={{ color: "#0b1c39", fontSize: "28px", fontWeight: "800", marginBottom: "40px", textAlign: "center" }}>
              Comprehensive Surgical Process
            </h3>

            <div className="row">
              <div className="col-lg-6 mb-4">
                <div style={{
                  backgroundColor: "#fff",
                  borderRadius: "20px",
                  padding: "40px",
                  boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
                  border: "2px solid #09bbaf",
                  height: "100%"
                }}>
                  <h4 style={{ color: "#0b1c39", marginBottom: "25px", fontSize: "24px", fontWeight: "800" }}>
                    Surgical Procedure Details
                  </h4>
                  
                  <p style={{ color: "#555", lineHeight: "1.8", marginBottom: "25px" }}>
                    Breast lift surgery is performed under general anesthesia in an accredited surgical facility. 
                    The procedure involves precise tissue reshaping and skin removal to create a naturally 
                    elevated breast contour.
                  </p>

                  <div style={{ marginBottom: "25px" }}>
                    <h6 style={{ color: "#09bbaf", fontWeight: "700", marginBottom: "15px" }}>Surgical Steps:</h6>
                    <div className="row">
                      <div className="col-6">
                        <ul style={{ color: "#555", paddingLeft: "20px", fontSize: "0.95rem" }}>
                          <li style={{ marginBottom: "8px" }}>Anesthesia administration</li>
                          <li style={{ marginBottom: "8px" }}>Incision planning and marking</li>
                          <li style={{ marginBottom: "8px" }}>Tissue reshaping and lifting</li>
                        </ul>
                      </div>
                      <div className="col-6">
                        <ul style={{ color: "#555", paddingLeft: "20px", fontSize: "0.95rem" }}>
                          <li style={{ marginBottom: "8px" }}>Nipple-areola repositioning</li>
                          <li style={{ marginBottom: "8px" }}>Excess skin removal</li>
                          <li style={{ marginBottom: "8px" }}>Layered closure with dissolvable sutures</li>
                        </ul>
                      </div>
                    </div>
                  </div>

                  <div>
                    <h6 style={{ color: "#09bbaf", fontWeight: "700", marginBottom: "15px" }}>Procedure Specifications:</h6>
                    <ul style={{ color: "#555", paddingLeft: "20px" }}>
                      <li style={{ marginBottom: "8px" }}>Duration: 2-4 hours</li>
                      <li style={{ marginBottom: "8px" }}>Anesthesia: General</li>
                      <li style={{ marginBottom: "8px" }}>Setting: Hospital or surgical center</li>
                      <li>Stay: Outpatient or 1-night observation</li>
                    </ul>
                  </div>
                </div>
              </div>

              <div className="col-lg-6 mb-4">
                <div style={{
                  backgroundColor: "#fff",
                  borderRadius: "20px",
                  padding: "40px",
                  boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
                  border: "2px solid #ffcb24",
                  height: "100%"
                }}>
                  <h4 style={{ color: "#0b1c39", marginBottom: "25px", fontSize: "24px", fontWeight: "800" }}>
                    Recovery & Aftercare
                  </h4>

                  <div style={{ marginBottom: "25px" }}>
                    <h6 style={{ color: "#09bbaf", fontWeight: "700", marginBottom: "15px" }}>First 2 Weeks:</h6>
                    <ul style={{ color: "#555", paddingLeft: "20px", marginBottom: "25px" }}>
                      <li style={{ marginBottom: "10px" }}>Wear surgical bra 24/7</li>
                      <li style={{ marginBottom: "10px" }}>Manage drainage tubes if placed</li>
                      <li style={{ marginBottom: "10px" }}>Limited arm movement</li>
                      <li style={{ marginBottom: "10px" }}>Pain medication as needed</li>
                      <li>Sleep on back with elevated upper body</li>
                    </ul>
                  </div>

                  <div style={{ marginBottom: "25px" }}>
                    <h6 style={{ color: "#09bbaf", fontWeight: "700", marginBottom: "15px" }}>Weeks 3-6:</h6>
                    <ul style={{ color: "#555", paddingLeft: "20px", marginBottom: "25px" }}>
                      <li style={{ marginBottom: "10px" }}>Gradual return to light activities</li>
                      <li style={{ marginBottom: "10px" }}>Transition to supportive sports bras</li>
                      <li style={{ marginBottom: "10px" }}>Scar care begins</li>
                      <li style={{ marginBottom: "10px" }}>Light walking encouraged</li>
                      <li>No heavy lifting or strenuous exercise</li>
                    </ul>
                  </div>

                  <div>
                    <h6 style={{ color: "#09bbaf", fontWeight: "700", marginBottom: "15px" }}>Long-term Care:</h6>
                    <ul style={{ color: "#555", paddingLeft: "20px" }}>
                      <li style={{ marginBottom: "10px" }}>Supportive bras during exercise</li>
                      <li style={{ marginBottom: "10px" }}>Sun protection for scars</li>
                      <li>Annual breast health monitoring</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Results Timeline */}
          <div style={{ marginBottom: "60px" }}>
            <h3 style={{ color: "#0b1c39", fontSize: "28px", fontWeight: "800", marginBottom: "40px", textAlign: "center" }}>
              Recovery Timeline & Expected Results
            </h3>

            <div style={{
              backgroundColor: "#fff",
              borderRadius: "20px",
              padding: "40px",
              boxShadow: "0 10px 30px rgba(0,0,0,0.08)"
            }}>
              <div className="row">
                {[
                  {
                    period: "Week 1-2",
                    title: "Initial Healing",
                    activities: ["Significant swelling", "Bruising present", "Surgical bra", "Restricted activity"]
                  },
                  {
                    period: "Week 3-6",
                    title: "Early Results",
                    activities: ["Swelling reduces 50%", "Bruising fades", "Light activities", "Scar care begins"]
                  },
                  {
                    period: "Month 2-3",
                    title: "Noticeable Improvement",
                    activities: ["70-80% final shape", "Most swelling gone", "Normal activities", "Exercise resumes"]
                  },
                  {
                    period: "Month 6+",
                    title: "Final Results",
                    activities: ["100% results visible", "Scars soften", "Natural feel", "Long-term maintenance"]
                  }
                ].map((stage, index) => (
                  <div key={index} className="col-lg-3 col-md-6 mb-4">
                    <div style={{
                      backgroundColor: "#f8f9fa",
                      borderRadius: "15px",
                      padding: "25px",
                      textAlign: "center",
                      border: "1px solid rgba(9,187,175,0.2)",
                      height: "100%"
                    }}>
                      <div style={{ 
                        backgroundColor: "#09bbaf", 
                        color: "white", 
                        width: "60px", 
                        height: "60px", 
                        borderRadius: "50%", 
                        display: "flex", 
                        alignItems: "center", 
                        justifyContent: "center", 
                        margin: "0 auto 15px",
                        fontWeight: "700",
                        fontSize: "0.9rem"
                      }}>
                        {stage.period}
                      </div>
                      <h5 style={{ color: "#0b1c39", fontWeight: "700", marginBottom: "15px", fontSize: "1.1rem" }}>
                        {stage.title}
                      </h5>
                      <ul style={{ color: "#555", fontSize: "0.85rem", paddingLeft: "15px", textAlign: "left" }}>
                        {stage.activities.map((activity, idx) => (
                          <li key={idx} style={{ marginBottom: "8px" }}>{activity}</li>
                        ))}
                      </ul>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Risks & Benefits */}
          <div style={{ marginBottom: "60px" }}>
            <div style={{
              backgroundColor: "#fff",
              borderRadius: "20px",
              padding: "40px",
              boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
              border: "2px solid rgba(255,203,36,0.3)"
            }}>
              <h3 style={{ color: "#0b1c39", fontSize: "28px", fontWeight: "800", marginBottom: "30px", textAlign: "center" }}>
                Benefits, Risks & Considerations
              </h3>

              <div className="row">
                <div className="col-md-6">
                  <div style={{ marginBottom: "25px" }}>
                    <h5 style={{ color: "#09bbaf", fontWeight: "700", marginBottom: "15px" }}>Key Benefits</h5>
                    <ul style={{ color: "#555", paddingLeft: "20px" }}>
                      <li style={{ marginBottom: "10px" }}>Restored youthful breast contour</li>
                      <li style={{ marginBottom: "10px" }}>Improved breast symmetry</li>
                      <li style={{ marginBottom: "10px" }}>Enhanced self-confidence</li>
                      <li>Better fitting clothing and bras</li>
                    </ul>
                  </div>
                </div>
                <div className="col-md-6">
                  <div style={{ marginBottom: "25px" }}>
                    <h5 style={{ color: "#09bbaf", fontWeight: "700", marginBottom: "15px" }}>Potential Risks</h5>
                    <ul style={{ color: "#555", paddingLeft: "20px" }}>
                      <li style={{ marginBottom: "10px" }}>Scarring (varies by technique)</li>
                      <li style={{ marginBottom: "10px" }}>Changes in nipple sensation</li>
                      <li style={{ marginBottom: "10px" }}>Asymmetry or contour irregularities</li>
                      <li>Rare complications like infection</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* FAQ Section */}
          <div style={{ marginBottom: "60px" }}>
            <h3 style={{ color: "#0b1c39", fontSize: "28px", fontWeight: "800", marginBottom: "40px", textAlign: "center" }}>
              Frequently Asked Questions
            </h3>

            <div style={{
              backgroundColor: "#fff",
              borderRadius: "20px",
              padding: "40px",
              boxShadow: "0 10px 30px rgba(0,0,0,0.08)"
            }}>
              {[
                {
                  question: "How long do breast lift results last?",
                  answer: "Breast lift results are long-lasting but not permanent. Most patients enjoy their results for 10-15 years, though individual factors affect longevity. Gravity, aging, weight fluctuations, and hormonal changes will continue to affect breast shape over time. Patients who maintain stable weight, wear supportive bras, and practice good skin care typically enjoy longer-lasting results. Pregnancy and breastfeeding after a breast lift can significantly alter results, so it's recommended to complete family planning before the procedure. While the lifted position may gradually descend over years, the improvement compared to pre-surgery condition remains significant. Many patients find the long-term benefits well worth the investment."
                },
                {
                  question: "Can I breastfeed after a breast lift?",
                  answer: "Many women can breastfeed after a breast lift, but there is a risk of impaired milk production. The ability to breastfeed depends on the surgical technique used and individual anatomy. Techniques that preserve the nipple-areola complex and its connection to milk ducts have higher success rates for breastfeeding. However, some milk ducts may be disrupted during surgery, potentially reducing milk supply. If future breastfeeding is important, discuss this with your surgeon during consultation. They can choose techniques that maximize preservation of breastfeeding function. It's generally recommended to complete family planning before breast lift surgery to avoid potential complications with future pregnancies and breastfeeding."
                },
                {
                  question: "What's the difference between breast lift and breast augmentation?",
                  answer: "Breast lift and breast augmentation are different procedures with distinct goals: A breast lift (mastopexy) raises and reshapes sagging breasts by removing excess skin and tightening tissue, but doesn't change breast size significantly. Breast augmentation increases breast size and fullness using implants or fat transfer, but doesn't correct significant sagging. Many patients benefit from a combination procedure (augmentation-mastopexy) that both lifts the breasts and adds volume. The choice depends on your goals: choose a lift if you're happy with your breast size but want to correct sagging; choose augmentation if you want larger breasts with good shape; choose combined procedures if you want both larger and lifted breasts. Your surgeon can recommend the best approach during consultation."
                },
                {
                  question: "Will a breast lift reduce my breast size?",
                  answer: "A breast lift may slightly reduce breast size, but this is usually minimal. The procedure primarily removes excess skin rather than breast tissue, so cup size typically decreases by about half a size or less. However, the lifted and reshaped breasts often appear larger and fuller because they're positioned higher on the chest wall. If you desire significant size reduction along with lifting, a breast reduction with lift might be more appropriate. Conversely, if you want to maintain or increase volume while correcting sagging, a breast lift with augmentation combines both procedures. During your consultation, discuss your size preferences with your surgeon so they can tailor the procedure to achieve your desired outcome."
                },
                {
                  question: "How painful is breast lift recovery?",
                  answer: "Breast lift recovery involves moderate discomfort that is well-managed with prescribed pain medication. Most patients describe the first 2-3 days as the most uncomfortable, with feelings of tightness, swelling, and general soreness. Pain typically improves significantly after the first week and becomes more manageable with over-the-counter pain relievers. The surgical bra provides support and helps minimize discomfort. Many patients return to desk work within 1-2 weeks, though strenuous activities and exercise should be avoided for 4-6 weeks. Your surgeon will provide detailed pain management instructions and follow your recovery closely to ensure comfort throughout the healing process. Most patients find the temporary discomfort well worth the long-term benefits."
                }
              ].map((faq, index) => (
                <div key={index} style={{ 
                  marginBottom: "25px",
                  paddingBottom: "25px",
                  borderBottom: index < 4 ? "1px solid #eee" : "none"
                }}>
                  <h5 style={{ color: "#0b1c39", fontWeight: "700", marginBottom: "10px" }}>
                    {faq.question}
                  </h5>
                  <p style={{ color: "#555", lineHeight: "1.6", margin: 0 }}>
                    {faq.answer}
                  </p>
                </div>
              ))}
            </div>
          </div>

          {/* Final CTA */}
          <div style={{
            background: "linear-gradient(135deg, #0b1c39 0%, #09bbaf 100%)",
            borderRadius: "20px",
            padding: "60px 40px",
            textAlign: "center",
            color: "white"
          }}>
            <h2 style={{ fontSize: "2.5rem", fontWeight: "800", marginBottom: "20px" }}>
              Ready for Your Breast Transformation?
            </h2>
            <p style={{ fontSize: "1.2rem", marginBottom: "30px", opacity: "0.9", maxWidth: "600px", margin: "0 auto 30px" }}>
              Our expert plastic surgery team provides advanced breast lift procedures with natural-looking, beautiful results.
            </p>
            <button style={{
              padding: "18px 45px",
              borderRadius: "30px",
              border: "none",
              backgroundColor: "#ffcb24",
              color: "#0b1c39",
              fontWeight: "800",
              fontSize: "1.1rem",
              cursor: "pointer",
              transition: "all 0.3s ease"
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = "#ffd84f";
              e.currentTarget.style.transform = "translateY(-2px)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = "#ffcb24";
              e.currentTarget.style.transform = "translateY(0)";
            }}>
              Book FREE Consultation Now
            </button>
            <p style={{ marginTop: "20px", fontSize: "1rem", opacity: "0.8" }}>
              Plastic Surgery: <strong>080-6541-7705</strong> | Breast Surgery: <strong>080-6541-7716</strong>
            </p>
          </div>
        </section>
      </div>

      <Footer />
    </>
  );
};

export default BreastLiftSurgery;